import React from 'react';
import Button from '@atlaskit/button';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type RemoveGoalButtonViewProps = {
	onRemove: () => void;
};

const RemoveGoalButtonView = ({ onRemove }: RemoveGoalButtonViewProps) => {
	const { formatMessage } = useIntl();
	return (
		<Button
			testId="servicedesk-sla-settings.ui.metrics.metric.editable.form.goals.goal.fields.remove-goal-button.button"
			appearance="subtle"
			iconAfter={<EditorCloseIcon label="" />}
			onClick={onRemove}
			aria-label={formatMessage(messages.removeGoal)}
		/>
	);
};

export const RemoveGoalButton = RemoveGoalButtonView;
